<template>
  <footer class="px-4 py-8 md:pt-12">
    <!-- <div class="space-x-4 md:flex justify-center">
      <span>Characters: 826</span><span>Locations: 123</span
      ><span>Episodes: 51</span>
    </div> -->
    <div>
      <p class="text-center">
        Made with<span class="inline-block w-6">💙</span> by
        <a href="https://www.pascal-achard.me" rel="noopener" target="_blank"
          >Pascal Achard</a
        >
      </p>
    </div>
  </footer>
</template>

<script setup></script>

<style lang="scss" scoped></style>
